/* eslint-disable */
// @ts-nocheck
import { reducerWrapper } from '../support/utils';
import { LOADING_STATUS } from '../support/constants';
import {
  GET_AUDIENCE_SEGMENTS_AND_LATEST_AUDIENCES,
  UPDATE_EDITING_AUDIENCE_SEGMENT_SCRATCHPAD,
  UPDATE_NEW_AUDIENCE_SEGMENT_SCRATCHPAD,
  DUPLICATE_AUDIENCE_SEGMENT_BY_ID,
  UPDATE_AUDIENCE_SEGMENT_IN_STORE,
  DELETE_AUDIENCE_SEGMENT_FROM_STORE,
  GET_ACTIVE_AUDIENCE_SEGMENTS_COUNT,
  CREATE_AUDIENCE_SEGMENT,
  SET_AUDIENCE_SAVE_REQUEST_STATUS,
  CLEAR_NEW_AUDIENCE_SEGMENT_SCRATCHPAD,
  CLEAR_EDITING_AUDIENCE_SEGMENT_SCRATCHPAD,
  GET_INTEGRATABLE_AD_PARTNERS_LIST,
  GET_APP_VERSIONS,
} from '../actions/AudienceSegmentActions';
import { GET_AUDIENCES_FOR_AUDIENCE_SEGMENT } from '../actions/AudienceActions';
import type {
  AudienceReducer as AudienceReducerState,
  AudienceVersionAudiences,
  AudienceSegmentAudiences,
  Audience,
  AudienceIndexed,
  MaybeEmptyAudience,
  AudienceWithData,
} from '../types/audienceTypes';
export const INIT_STATE: AudienceReducerState = {
  loadingStatus: LOADING_STATUS.INIT,
  error: null,
  audienceSegments: {},
  audiences: {},
  newAudienceSegment: undefined,
  editingAudienceSegment: undefined,
  activeAudienceSegmentCount: undefined,
  audienceSaveRequestStatus: LOADING_STATUS.INIT,
  integratableAdPartners: null,
};
export function filterIncomingAudiencesForNonEmptyAudiences(incomingAudiences: MaybeEmptyAudience[]): AudienceWithData[] {
  const audiencesWithData: AudienceWithData[] = [];
  incomingAudiences.forEach((maybeEmptyAudience) => {
    if (maybeEmptyAudience.dataDate) {
      audiencesWithData.push(maybeEmptyAudience);
    }
  });
  return audiencesWithData;
}
export function mergeIncomingAudiencesIntoIndexedAudiences(
  incomingAudiences: Audience[],
  indexedAudiences: AudienceIndexed
): AudienceIndexed {
  return incomingAudiences.reduce(
    (audiences, audience) => {
      const { audienceSegment } = audience;
      const { id: audienceSegmentId } = audienceSegment;
      const existingAudiencesForSegment = audiences[audienceSegmentId];
      const mergedAudiencesForSegment = mergeIncomingAudienceIntoAudiencesForSegment(audience, existingAudiencesForSegment);
      audiences[audienceSegmentId] = mergedAudiencesForSegment;
      return audiences;
    },
    { ...indexedAudiences }
  );
}
export function mergeIncomingAudienceIntoAudiencesForSegment(
  incomingAudience: Audience,
  audiencesForSegment?: AudienceSegmentAudiences
) {
  const { versionId } = incomingAudience.audienceSegment;
  const existingAudiencesForVersion = audiencesForSegment && audiencesForSegment[versionId];
  const mergedAudiencesForVersion = mergeIncomingAudienceIntoAudiencesForVersion(
    incomingAudience,
    existingAudiencesForVersion
  );

  if (!audiencesForSegment) {
    return {
      [versionId]: mergedAudiencesForVersion,
    };
  }

  return { ...audiencesForSegment, [versionId]: mergedAudiencesForVersion };
}
export function mergeIncomingAudienceIntoAudiencesForVersion(
  incomingAudience: Audience,
  audiencesForVersion?: AudienceVersionAudiences
) {
  const { dataDate } = incomingAudience;

  if (!audiencesForVersion) {
    return {
      [dataDate]: incomingAudience,
    };
  }

  return { ...audiencesForVersion, [dataDate]: incomingAudience };
}
export const DUPLICATE_AUDIENCE_SEGMENT_PROPERTIES_BLACKLIST = [
  'id',
  'versionId',
  'createdAt',
  'createdBy',
  'lastUpdatedAt',
  'lastUpdatedBy',
  'name',
];
export function Handler(
  state: AudienceReducerState = INIT_STATE,
  action: {
    type: string;
    data: any;
  }
) {
  let segmentId;
  let updatedAudienceSegments;
  let mergedAudiences;
  let nonEmptyAudiences;

  switch (action.type) {
    case GET_AUDIENCE_SEGMENTS_AND_LATEST_AUDIENCES.response:
      const fetchedAudienceSegments = action.data.reduce((audienceSegments, audience) => {
        const { audienceSegment } = audience;
        const { id } = audienceSegment;
        audienceSegments[id] = audienceSegment;
        return audienceSegments;
      }, {});
      const mergedAudienceSegments = { ...state.audienceSegments, ...fetchedAudienceSegments };
      nonEmptyAudiences = filterIncomingAudiencesForNonEmptyAudiences(action.data);
      // Audiences are a non-archivable/non-hideable resource, so unless the app resets,
      // there's not reason to clear and repopulate audiences within a session.
      mergedAudiences = mergeIncomingAudiencesIntoIndexedAudiences(nonEmptyAudiences, state.audiences);
      return { ...state, audienceSegments: mergedAudienceSegments, audiences: mergedAudiences };

    case GET_ACTIVE_AUDIENCE_SEGMENTS_COUNT.response:
      return { ...state, activeAudienceSegmentCount: action.data.count };

    case CREATE_AUDIENCE_SEGMENT.response:
      const newAudienceSegment = action.data;
      updatedAudienceSegments = { ...state.audienceSegments, [newAudienceSegment.id]: newAudienceSegment };
      return { ...state, audienceSegments: updatedAudienceSegments };

    case GET_INTEGRATABLE_AD_PARTNERS_LIST.response:
      return { ...state, integratableAdPartners: action.data };

    case UPDATE_EDITING_AUDIENCE_SEGMENT_SCRATCHPAD:
      if (!state.editingAudienceSegment) {
        return { ...state, editingAudienceSegment: action.data };
      }

      const updatedEditingAudienceSegment = { ...state.editingAudienceSegment, ...action.data };
      return { ...state, editingAudienceSegment: updatedEditingAudienceSegment };

    case UPDATE_NEW_AUDIENCE_SEGMENT_SCRATCHPAD:
      if (!state.newAudienceSegment) {
        return { ...state, newAudienceSegment: action.data };
      }

      const updatedNewAudienceSegment = { ...state.newAudienceSegment, ...action.data };
      return { ...state, newAudienceSegment: updatedNewAudienceSegment };

    case CLEAR_NEW_AUDIENCE_SEGMENT_SCRATCHPAD:
      return { ...state, newAudienceSegment: undefined };

    case CLEAR_EDITING_AUDIENCE_SEGMENT_SCRATCHPAD:
      return { ...state, editingAudienceSegment: undefined };

    case DUPLICATE_AUDIENCE_SEGMENT_BY_ID:
      const duplicatedAudienceSegment = state.audienceSegments[action.data] || {};
      const sanitizedAudienceSegment = { ...duplicatedAudienceSegment };
      DUPLICATE_AUDIENCE_SEGMENT_PROPERTIES_BLACKLIST.forEach((key) => {
        delete sanitizedAudienceSegment[key];
      });
      return { ...state, newAudienceSegment: sanitizedAudienceSegment };

    case UPDATE_AUDIENCE_SEGMENT_IN_STORE:
      segmentId = action.data.id;
      const audienceSegmentToUpdate = state.audienceSegments[segmentId];
      const updatedAudienceSegment = { ...audienceSegmentToUpdate, ...action.data };
      updatedAudienceSegments = { ...state.audienceSegments, [segmentId]: updatedAudienceSegment };
      return { ...state, audienceSegments: updatedAudienceSegments };

    case DELETE_AUDIENCE_SEGMENT_FROM_STORE:
      segmentId = action.data;
      updatedAudienceSegments = { ...state.audienceSegments };
      delete updatedAudienceSegments[segmentId];
      const updatedAudiences = { ...state.audiences };
      delete updatedAudiences[segmentId];
      return { ...state, audienceSegments: updatedAudienceSegments, audiences: updatedAudiences };

    case GET_AUDIENCES_FOR_AUDIENCE_SEGMENT.response:
      nonEmptyAudiences = filterIncomingAudiencesForNonEmptyAudiences(action.data);
      mergedAudiences = mergeIncomingAudiencesIntoIndexedAudiences(nonEmptyAudiences, state.audiences);
      return { ...state, audiences: mergedAudiences };

    case SET_AUDIENCE_SAVE_REQUEST_STATUS:
      return { ...state, audienceSaveRequestStatus: action.data };

    default:
      return state;
  }
}
const AudienceReducer = reducerWrapper(INIT_STATE, Handler, {
  request: [],
  error: [],
  resetOn: ['APP_CHANGE'],
});
export default AudienceReducer;
